import { jsx as _jsx } from "react/jsx-runtime";
import { createRef } from 'react';
import { ModuleFE_WorkHub } from '../../_module/index.js';
import './Component_WorkHub_TabContent.scss';
import { AwaitModules, ComponentSync, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend';
import { voidFunction } from '@nu-art/ts-common';
export class Component_WorkHub_TabContent extends ComponentSync {
    ref = createRef();
    // ######################## Life Cycle ########################
    __onWorkHubTabsUpdated = () => {
        this.reDeriveState();
    };
    //We get the selected tab from the props, ignore updates here
    __onWorkHubTabSelected = voidFunction;
    deriveStateFromProps(nextProps, state) {
        state.tab = nextProps.tab;
        state.item = ModuleFE_WorkHub.workHubItem.getByKey(state.tab.itemKey);
        state.renderArgs = { ...state.tab.renderArgs };
        return state;
    }
    componentDidMount() {
        this.ref.current?.focus();
    }
    componentDidUpdate() {
        this.ref.current?.focus();
    }
    // ######################## Render ########################
    render() {
        if (this.state.item.modulesToAwait?.length)
            return this.renderAsync();
        return this.renderSync();
    }
    renderAsync = () => {
        const item = this.state.item;
        const tab = this.state.tab;
        return _jsx("div", { className: 'c__work-hub-tab-content', ref: this.ref, tabIndex: 0, children: _jsx(AwaitModules, { modules: item.modulesToAwait, children: _jsx(TS_ErrorBoundary, { children: item.renderer(item, tab.id, tab.renderArgs) }) }) });
    };
    renderSync = () => {
        const item = this.state.item;
        return _jsx("div", { className: 'c__work-hub-tab-content', ref: this.ref, tabIndex: 0, children: _jsx(TS_ErrorBoundary, { children: item.renderer(item, this.state.tab.id, this.state.renderArgs) }) });
    };
}
//# sourceMappingURL=Component_WorkHub_TabContent.js.map